module.exports = __webpack_public_path__ + "img/fish_pufferfish.7507b71d.png";